import type { AxiosResponse } from "axios";

import { downloadFile, validateValues } from "../../utils";
import api from "../../../../../api";
import type { CommandFormValues } from "../../types";
import type { IUser } from "../../../../../types";
import {
  buildExportFileName,
  getFileNameFromContentDisposition,
} from "../../../../../utils";
import { exportSusaRequestSchema } from "./types";

/**
 * The backend names the download via Content-Disposition; if that header is
 * not readable, build the same customer-first name here.
 */
const buildFileName = (
  user: IUser,
  year: number,
  fromMonth: number,
  toMonth: number
): string =>
  buildExportFileName({
    user,
    exportType: "SuSa",
    period: {
      kind: "monthRange",
      from: { year, month: fromMonth },
      to: { year, month: toMonth },
    },
    extension: "pdf",
  });

export const handleExportSusa = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date, fromMonth, toMonth } = validateValues(
    values,
    exportSusaRequestSchema
  );

  const response = await api.kontax.exportSusa(
    user.id,
    date.year(),
    fromMonth,
    toMonth
  );

  const contentTypeHeader = response.headers["content-type"];
  const contentType =
    typeof contentTypeHeader === "string" ? contentTypeHeader : undefined;

  const contentDispositionHeader = response.headers["content-disposition"];
  const contentDisposition =
    typeof contentDispositionHeader === "string"
      ? contentDispositionHeader
      : undefined;

  const blob = new Blob([response.data], {
    type: contentType,
  });

  const downloadUrl = window.URL.createObjectURL(blob);
  const fileName =
    getFileNameFromContentDisposition(contentDisposition) ||
    buildFileName(user, date.year(), fromMonth, toMonth);

  downloadFile(downloadUrl, fileName);
  // Revoke the object URL to avoid memory leaks.
  window.URL.revokeObjectURL(downloadUrl);

  return response;
};
